<template>
  <div class="bcw bcw__parcels_effort">
    <header>
      <p class="title">{{ trans('dashboard.eff.title1') }} <span>{{ trans('dashboard.eff.title2') }}</span></p>
      <p class="subtitle">{{ trans('dashboard.eff.sub') }}</p>
    </header>
    <main>
      <leaderboard :list="this.list_percs" :opt="this.options"></leaderboard>
    </main>
  </div>
</template>

<style lang="scss" scoped >

</style>


<script>
    export default {

        props: [
            'widget',
        ],

        data(){
            return {
              'list_percs': this.fillList(),
              'options': {
                'with_img': true
              }
            };
        },

        methods: {

          fillList() {

            const factor = 1.2;
            const top = 5;

            let temp = this.widget.data();

            let maxNum = 0;

            this.widget.data().forEach((line) => {
              if (line.num_samples > maxNum) maxNum = line.num_samples;
            })

            maxNum = maxNum * factor;

            const myList =  this.widget.data().map((line) => {
              return {
                name: line.user_name,
                value: 'x' + line.num_samples,
                perc: line.num_samples / maxNum,
                bg: line.logo_name,
                img: "/crop/pic/color/" + line.logo_name
              }
            })

            return myList.slice(0, top);
          }
        }
    }

</script>